import { useQuery } from '@tanstack/react-query';
import { getCustomerProfile } from '../../api/apiStorefront';
import { useAuthContext } from '../../auth/useAuthContext';

export const useGetCustomerProfile = () => {
  const { isAuthenticated } = useAuthContext();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['customer-profile'],
    queryFn: async () => {
      const response = await getCustomerProfile();
      return response?.data || null;
    },
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });

  const profile = data?.data || null;

  return { profile, isLoading, error, refetch };
};
